import { ComponentType, Fragment, useState } from 'react';
import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '../ui/form';
import { Input, InputProps } from '../ui/input';
import { Control } from 'react-hook-form';
import { cn } from '@/lib/utils';
import { EyeClosedIcon, EyeOpenIcon } from '@radix-ui/react-icons';
import { numberMask } from '@/common/utils/masks';

interface InputControlProps extends InputProps {
  control?: Control<any>;
  name: string;
  inputClass?: string;
  label?: string | null;
  labelClass?: string;
  placeholder?: string | any;
  description?: string;
  required?: boolean;
  isNumber?: boolean;
  maxLength?: number;
  notRequired?: boolean;
  withoutDescription?: boolean | undefined;
}

export const InputControl: ComponentType<InputControlProps> = ({
  control,
  label,
  description,
  name,
  inputClass,
  className,
  labelClass,
  type: inputType,
  required,
  isNumber,
  maxLength,
  notRequired,
  withoutDescription,
  ...rest
}) => {
  const [type, setType] = useState(inputType);

  const onSetType = () => {
    if (type === 'text') {
      setType('password');
    } else {
      setType('text');
    }
  };

  return (
    <FormField
      control={control}
      name={name}
      render={({ field: { value, onChange, ...field } }) => (
        <FormItem className={cn(className)}>
          {label && (
            <FormLabel className={labelClass}>
              {label} {required && <span className={cn('text-red')}>*</span>}
            </FormLabel>
          )}
          <FormControl>
            <div className="relative">
              <Input
                {...rest}
                {...field}
                required={false}
                value={value ?? ''}
                className={cn(
                  inputClass,
                  'w-full rounded-lg border-gray-200 bg-white ',
                )}
                type={type}
                maxLength={maxLength}
                onChange={(e) => {
                  let inputValue = e.target.value;
                  if (isNumber) {
                    const maskedValue = numberMask(e.target.value);
                    if (maxLength && maskedValue.length > maxLength) {
                      return;
                    }
                    onChange(maskedValue);
                  } else {
                    onChange(e.target.value);
                  }
                  if (maxLength && inputValue.length > maxLength) {
                    inputValue = inputValue.slice(0, maxLength);
                  }
                  onChange(inputValue);
                }}
              />
              {inputType === 'password' ? (
                <a
                  className="absolute right-4 top-1/2 -translate-y-1/2 cursor-pointer"
                  onClick={onSetType}
                >
                  {type === 'text' ? <EyeOpenIcon /> : <EyeClosedIcon />}
                </a>
              ) : null}
            </div>
          </FormControl>
          {withoutDescription ? null : (
            <Fragment>
              {description && <FormDescription>{description}</FormDescription>}
              {!notRequired && (
                <div className={'h-4 !mt-1'}>
                  <FormMessage />
                </div>
              )}
            </Fragment>
          )}
        </FormItem>
      )}
    />
  );
};
